<template>
  <div class="network-graph-hc">
    <div ref="container" class="chart-box"></div>
  </div>

</template>

<script>
import Highcharts from 'highcharts'
import Networkgraph from 'highcharts/modules/networkgraph'
import Exporting from 'highcharts/modules/exporting'

Networkgraph(Highcharts)
Exporting(Highcharts)

export default {
  name: 'NetworkGraph',
  props: {
    edges: {type: Array, required: true},
    nodes: {type: Array, default: () => []}
  },
  data() {
    return {chart: null, ro: null}
  },
  mounted() {
    this.renderChart()
    this.ro = new ResizeObserver(() => {
      if (!this.chart) return
      const el = this.$refs.container
      this.chart.setSize(el.clientWidth, el.clientHeight, false)
    })
    this.ro.observe(this.$refs.container)
  },
  beforeDestroy() {
    if (this.ro) this.ro.disconnect()
  },
  watch: {
    edges() {
      this.updateSeries()
    },
    nodes() {
      this.updateSeries()
    }
  },
  methods: {
    renderChart() {
      const el = this.$refs.container
      this.chart = Highcharts.chart(el, {
        chart: {
          type: 'networkgraph',
          styledMode: false, //
          events: {
            load: function () {
              this.setSize(el.clientWidth, el.clientHeight, false)
            }
          },
          zooming: {mouseWheel: true, type: 'xy'}
        },
        title: {text: '', align: 'top'},
        credits: {enabled: false},
        legend: {enabled: false},
        plotOptions: {
          networkgraph: {
            keys: ['from', 'to'],
            dataLabels: {
              enabled: true,
              linkFormat: '',
              style: {textOutline: 'none', fontSize: '10px'}
            },
            layoutAlgorithm: {
              enableSimulation: true,
              integration: 'verlet', // euler or verlet laypout mode
              linkLength: 160
            },
            link: {
              width: 1.2, //linewidth
            },
            point: {
              events: {
                click: function () {
                  if (this.isNode) {
                    const base_url = window.location.origin;
                    const internal_id = this.id
                    const url = `${base_url}/#/single-search/${internal_id}?ptm_type=phosphorylation`;
                    window.open(url, '_blank');
                  }
                }
              }
            }

          }
        },
        tooltip: {
          useHTML: true,
          formatter() {
            const p = this.point
            if (p.isNode) {
              const s = (typeof p.score === 'number') ? p.score.toFixed(6) : p.score
              return `<b>${p.name}</b><br/>#Related Nodes: ${p.degree ?? 0}`
              // return `<b>${p.name}</b><br/>score: ${s}<br/>#Related Nodes: ${p.degree ?? 0}`
            } else {
              return `Edge: ${p.from} — ${p.to}`
            }
          }
        },

        series: [{
          id: 'net',
          type: 'networkgraph',
          accessibility: {enabled: false},
          data: this.edges || [],
          nodes: this.nodes || [],
          color: '#3D5AFE' //node color
        }],
        exporting: {
          enabled: true,
          sourceWidth: 800,
          sourceHeight: 500,
          scale: 8,
          allowHTML: false,
          chartOptions: {
            plotOptions: {
              networkgraph: {
                dataLabels: {
                  enabled: true,
                  allowOverlap: true,
                  crop: false,
                  overflow: 'allow',
                  style: {textOutline: 'none', fontSize: '12px', color: '#111'},
                  formatter() {
                    const parts = this.point.name.split('_')
                    return `${parts[0]}_${parts[1]}`
                    // return this.point.name
                  }
                },
                layoutAlgorithm: {enableSimulation: false}
              }
            }
          },
          buttons: {contextButton: {menuItems: ['downloadPNG', 'downloadSVG']}}
        }

      })
    },
    updateSeries() {
      if (!this.chart) return
      const s = this.chart.get('net')

      if (s) {
        s.setData(this.edges || [], false)
        s.update(
            { nodes: this.nodes || [] },
            false
        )
      } else {
        this.chart.addSeries({
          id: 'net',
          type: 'networkgraph',
          data: this.edges || [],
          nodes: this.nodes || []
        }, false)
      }
      this.chart.redraw()
    }

  }
}
</script>

<style scoped>
.network-graph-hc {
  width: 100%;
  display: flex;
  justify-content: center;
}

.chart-box {
  width: min(95vw, 800px);
  height: min(90vh,600px);
}

</style>
